/**
 * @name 倒计时组件
 * @description 根据传递进来的结束时间，把离结束时间-当前时间的时间转化为 天、小时、分钟、秒通过回调传递
 */
import { PureComponent } from "react";
/**
 * 倒计时组件
 * @class
 * @version 1.0.0
 */

export class CountDown extends PureComponent {
  constructor(props) {
    super(props);
    this.timerID = 0;

    this.handleStart = () => {
      const nowTime = Date.now();

      if (this.props.endTime && this.props.endTime - nowTime > 0) {
        this.timerID = window.setInterval(() => {
          let remainTime = 0;
          const nowTime = Date.now();
          remainTime = (this.props.endTime - nowTime) / 1000;

          if (remainTime < 0) {
            clearInterval(this.timerID);
            this.props.onTimeOver && this.props.onTimeOver();
          } else {
            this.setState({
              timeInfo: this.countdown(remainTime)
            });
          }
        }, this.props.millisecondMode ? 100 : 1000);
      }
    };

    let remainTime = 0;
    const nowTime = Date.now();
    remainTime = ((props.endTime || 0) - nowTime) / 1000;
    this.state = {
      timeInfo: this.countdown(remainTime)
    };
  }

  componentDidMount() {
    this.handleStart();
  }

  componentWillUnmount() {
    if (this.timerID) {
      clearInterval(this.timerID);
    }
  }

  countdown(remainTime) {
    // 剩余时间不能小于0
    remainTime = remainTime < 0 ? 0 : remainTime;
    const day = Math.floor(remainTime / (24 * 60 * 60));
    const hours = Math.floor(remainTime / (60 * 60) % 24);
    const hoursStr = this.formate(hours);
    const minutes = Math.floor(remainTime / 60 % 60);
    const minutesStr = this.formate(minutes);
    const seconds = Math.floor(remainTime % 60);
    const secondsStr = this.formate(seconds);
    const timeInfo = {
      day,
      hours,
      hoursStr,
      minutes,
      minutesStr,
      seconds,
      secondsStr
    };

    if (this.props.millisecondMode) {
      const milliseconds = Math.floor(remainTime * 1000);
      const millisecondsStr = String(milliseconds).substr(-3, 3);
      timeInfo.milliseconds = milliseconds;
      timeInfo.millisecondsStr = millisecondsStr;
    }

    return timeInfo;
  }

  formate(time) {
    return `${time < 10 ? "0" : ""}${time}`;
  }

  render() {
    const {
      children
    } = this.props;
    const {
      timeInfo
    } = this.state;
    return children(timeInfo);
  }

}